import { HTTPService } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { Grid } from "../core/components/grid";
import { Config } from "../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Dialog, DialogProps } from "../core/components/dialog";
import { DropDownList } from "../core/components/dropDownList";
import { ComponentHelper } from "../core/util/componentHelper";
import { FieldInstance } from "../core/components/field";
import { BaseComponentProps, BaseField } from "../core/components/baseComponentProps";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";

export default class RightsSettings extends React.Component<RightsSettingsProps, RightsSettingsState>{
    private dataSource: any[];
    private translations: StringKeyDictionary<string>;
    private id: string;
    private gridOptions: kendo.ui.GridOptions;
    private initialized: boolean;
    private dialogRef: Dialog;
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: "",
        width: 450,
        actions: [
            {
                action: () => {

                },
                label: Config.translations.cancel,
                primary: false
            },
            {
                action: () => {
                    let gridData = this.state.dataSource;
                    let index = gridData.findIndex(f => f[this.props.field.idField] == this.state.selected[this.props.field.idField])
                    gridData[index]["Recht"] = this.state.dialogValue;
                    this.changeValues(gridData);
                },
                label: Config.translations.ok,
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false, dialogValue: null })
        }
    }
    constructor(props: RightsSettingsProps) {
        super(props)
        if (Helper.isNullOrEmpty(props.field.guid)) {
            this.id = `${kendo.guid()}`;
        } else {
            this.id = `${props.field.guid}`;
        }
        this.initialized = false;
        this.state = {
            dataSource: props.value,
            selected: null,
            dialogOpen: false,
            dialogValue: null
        }
        this.initApp();
    }

    private changeValues = (gridData: {}[]) => {
        this.setState({ dataSource: gridData }, () => {
            this.props.onChange(this.props.field, gridData)
        })
    }

    private initApp = () => {
        Promise.all([
            HTTPService.get(this.props.field.dataSourceUrl),
            Helper.getTranslations(["Statistik.Recht"])
        ]).then((results) => {
            this.dataSource = results[0];
            this.translations = results[1].Data;
            this.setGridOptions();
            this.initialized = true;
            this.setState({})
        });
    }

    private setGridOptions = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: this.props.field.rightField,
                    title: this.props.field.rightTitle
                },
                {
                    field: "Recht",
                    title: this.translations["Statistik.Recht"]
                }
            ]
        };
    }
        
       
    private createGrid = () => {
        let standardButtons: ToolBarStandardButton[] = [
            { caption: Config.translations.editLabel, enabled: !this.props.entity.UserHasRole, type: ToolBarStandardButtonType.EDIT }
        ];
        let grid =
            <div style={{ height: "300px" }}>
                <Grid
                    
                    standardButtons={standardButtons}
                    data={this.props.entity.GeneralSettings.AdrTypRights}
                    options={this.gridOptions}
                    id="UserRightsSettingsGrid"
                    onClickStandardButton={this.onStandardClick}
                    onSelectionChanged={(dataItem) => { this.setState({ selected: dataItem }) }}
                />
            </div>
        return grid;
    }


    private onStandardClick = (type: ToolBarStandardButtonType) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.setState({ dialogOpen: true, dialogValue: this.state.selected["Recht"] })
                break;
        }
    }

    private createDialog = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.dataSource;
        props.field.dataTextField = this.props.field.dataTextField;
        props.field.dataValueField = this.props.field.dataValueField;
        props.field.optionLabel = "";
        props.value = this.state.dialogValue;
        props.onChange = (field, value, dataItem) => {
            this.setState({ dialogValue: value })
        }
        return (
            <Dialog {...this.dialogProps} ref={(ref) => { this.dialogRef = ref }} open={this.state.dialogOpen}>
                <FieldInstance label={this.translations["Statistik.Recht"]}>
                    <DropDownList {...props} />
                </FieldInstance>
            </Dialog>
        );
    }

    render() {
        const grid = this.initialized ? this.createGrid() : null;
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        return <>{grid}{dialog}</>;
    }

}

interface RightsSettingsProps extends BaseComponentProps {
    field: RightsSettingsField;
    value: {}[];
    entity: any;
}

interface RightsSettingsField extends BaseField {
    rightField: string;
    rightTitle: string;
    dataSourceUrl: string;
    dataTextField: string;
    dataValueField: string;
    idField: string;
}

interface RightsSettingsState {
    dataSource: {}[];
    selected: any;
    dialogOpen: boolean;
    dialogValue: number;
}